import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'components.npsmodal.title',
    defaultMessage: 'Consent agreement',
  },
  content: {
    id: 'components.npsmodal.content',
    defaultMessage:
      'To help us improve our service, do you agree us to send a survey in order to get your satisfaction ?',
  },
  yes: {
    id: 'components.npsmodal.action.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'components.npsmodal.action.no',
    defaultMessage: 'No',
  },
});
